import {useSelector} from 'react-redux';
import {EMPTY_LIST} from '../../constants/empty.constants';

/**
 * The company's employees, with a reference-stable empty fallback.
 *
 * Replaces `useSelector(state => state.company?.employees ?? [])`, which was written out at 23 call
 * sites and made every one of them re-render on every dispatch (see `empty.constants`).
 *
 * @returns {Array<Object>} Employees for the current company, or a shared empty array.
 */
export const useCompanyEmployees = () => useSelector(state => state.company?.employees ?? EMPTY_LIST);
